<div class="p-3">
    <h2>Game Logs</h2>
    <form class="d-flex flex-row border-bottom pb-2 align-items-end gap-3" (submit)="filter()">
        <div class="form-group">
            <label for="from">From</label>
            <input class="form-control" type="datetime-local" id="from" name="from" [(ngModel)]="data.date_from">
        </div>
        <div class="form-group">
            <label for="to">To</label>
            <input class="form-control" type="datetime-local" id="to" name="to" [(ngModel)]="data.date_to">
        </div>
        <button class="btn btn-success" type="submit" >Submit</button>
    </form>
</div>

<div class="p-3">
    <h2 class="text-danger" *ngIf="error_message">{{error_message}}</h2>
    <button class="btn btn-outline-warning" type="button" *ngIf="!error_message && load && items.length == 0" disabled="disabled">
        <h3 class="text-warning fw-bolder mb-0">No Data Available</h3>
    </button>
 
    <div class="py-3 w-100 mb-3" *ngIf="content" [innerHTML]="content"></div>

    <table class="table table-sm" *ngIf="!error_message && items.length > 0 && load">
        <thead>
            <tr>
                <th>Player</th>
                <th>Game</th>
                <th>Match / Event</th>
                <th>Bet On</th>
                <th>Bet Amount</th>
                <th>Valid Bet</th>
                <th>Payout Amount</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of items">
            <tr>
                <td>{{item.player}}</td>
                <td>{{item.game_name}}</td>
                <td>
                    <ng-container *ngIf="hasDetail(item); else noMatchA">
                        <span class="gl-match" (click)="toggleExpand(item)" title="Click to view all selections" style="cursor:pointer">
                            <span class="gl-caret">{{ isExpanded(item) ? '▾' : '▸' }}</span>
                            {{ matchSummary(item) }}
                        </span>
                    </ng-container>
                    <ng-template #noMatchA><span class="text-muted">—</span></ng-template>
                </td>
                <td>{{item.bet_time}}</td>
                <td>{{item.bet_amount}}</td>
                <td>{{item.valid_bet}}</td>
                <td>{{item.payout}}</td>
                <td>
                    <button class="btn btn-sm btn-primary" (click)="view(item)" *ngIf="item.bet_id">View</button>
                </td>
            </tr>
            <tr *ngIf="hasDetail(item) && isExpanded(item)" class="gl-detail-row">
                <td colspan="8">
                    <div class="gl-detail">
                        <div class="gl-detail-head">
                            {{ item.game_detail.sportName }}
                            <span *ngIf="item.game_detail.betType"> · {{ item.game_detail.betType }}</span>
                            <span *ngIf="item.game_detail.totalOdds"> · total odds {{ item.game_detail.totalOdds }}</span>
                            <span *ngIf="item.game_detail.legs.length > 1"> · {{ item.game_detail.legs.length }} legs (parlay)</span>
                        </div>
                        <div class="gl-leg" *ngFor="let leg of item.game_detail.legs">
                            <div class="gl-leg-event">
                                <span class="text-muted" *ngIf="leg.leagueName">{{ leg.leagueName }} · </span>
                                <span class="fw-semibold">{{ leg.eventName || (leg.homeTeam + ' vs ' + leg.awayTeam) }}</span>
                                <span class="badge bg-danger ms-1" *ngIf="leg.live">LIVE</span>
                                <span class="text-muted ms-1" *ngIf="leg.liveScore">({{ leg.liveScore }})</span>
                            </div>
                            <div class="gl-leg-sel">
                                {{ legSelection(leg) }}
                                <span class="ms-2" [ngClass]="legResultClass(leg)" *ngIf="leg.legStatus">[{{ leg.legStatus }}]</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            </ng-container>
        </tbody>
    </table>
</div>